<template>
  <mdb-card class="grey lighten-5 w-75 mx-auto">
    <mdb-card-body>
      <mdb-card-text class="p-4">
        <p class="sub-title">훈련생 유의사항</p>
        <p>귀하께서 수강중인 NCS 기반 훈련과정은 고용노동부로부터 실업자 직업능력 개발 훈련 과정으로 지정받은 과정입니다.</p>
        <p>귀하께서는 아래의 사항에 유의하여 평가에 임해주시기 바랍니다.</p>
        <p class="mt-4 bolder">⓵ 이수기준</p>
        <p>- 모든 평가에 참여해야 하며 평균점수가 60점 이상 되어야 합니다.</p>
        <p>* 평가는 최대 2회까지 참여 가능합니다.</p>
        <p class="mt-4 bolder">⓶ 평가자료 제출 방법</p>
        <p>- 작업장 평가 등 실습으로 이루어지는 평가는 본인의 작업 결과물을 웹 페이지에 반드시 제출 마감일까지 직접 업로드 해주셔야 합니다.</p>
        <p class="mt-4 bolder">⓷ 평가자료 피드백</p>
        <p>- 평가 종류 후 10일 이내에 교사의 피드백을 확인할 수 있습니다.</p>
        <p>평가에 대한 질의사항이 있을 경우, 해당 담당 강사를 통해 질의 부탁 드립니다.</p>
        <p class="mt-4 bolder text-center">
          <input type="checkbox" id="agreement" v-model="agreement"/> <label for="agreement">동의합니다.</label> <br/>
          <mdb-btn class="py-2" icon="check" @click="$emit('success-agreement')" :disabled="!agreement">확인</mdb-btn>
        </p>
      </mdb-card-text>
    </mdb-card-body>
  </mdb-card>
</template>
<script>
import { mdbCard, mdbCardBody, mdbCardText } from 'mdbvue';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
export default {
  name: 'TestAgreement',
  components: { mdbCard, mdbCardBody, mdbCardText },
  props: [],
  data: () => ({
    agreement: false
  }),
  computed: {
    ...mapState('auth', ['profile']),
    ...mapGetters('auth', ['isStudent'])
  }
}
</script>
